import { IStyle } from '@fluentui/react';
import { ICorptaxTheme } from '../ICorptaxTheme';
import { ICscBrandStyles } from './ICscBrandStyles';

export class CorptaxThemeCscBrandStyles implements ICscBrandStyles {
    private cscLogoWidth = 90;
    private horizontalLogoPadding = 5;
    private chevronWidth = 15;
    private chevronLeft = this.horizontalLogoPadding * 2 + this.cscLogoWidth;
    private baseChevronStyle;

    constructor(
        private theme: ICorptaxTheme,
        private height: number,
        private toggleButtonWidth: number
    ) {
        this.baseChevronStyle = {
            display: 'block',
            position: 'absolute',
            left: this.chevronLeft,
            border: `${this.height / 2}px solid transparent`,
            borderRight: 'none',
            borderLeftWidth: this.chevronWidth,
            zIndex: 1,
            borderLeftColor: this.theme.palette.white,
        };
    }

    get outerContainerStyles() {
        return {
            marginRight: `${this.chevronWidth + 10}px !important`,
        };
    }
    get containerStyles() {
        return {
            alignItems: 'center',
            display: 'flex',
            background: this.theme.palette.white,
            height: this.height,
        };
    }
    get logoContainerStyles() {
        return {
            background: this.theme.palette.white,
            paddingLeft: this.horizontalLogoPadding,
            paddingRight: this.horizontalLogoPadding,
        };
    }
    get logoStyles() {
        return {
            width: this.cscLogoWidth,
            height: 'auto',
        };
    }
    get chevronStyles() {
        return this.baseChevronStyle as IStyle;
    }
    get chevronStylesWithNav() {
        return {
            ...this.baseChevronStyle,
            left: this.chevronLeft + this.toggleButtonWidth,
        } as IStyle;
    }
}
